import PrescriptionFillEditModalContainer from './send-receipt-modal-container';

export default PrescriptionFillEditModalContainer;
